import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import { FooterAPI } from 'API/GeneralAPI';
import { FooterType } from './Types';

const FooterContainer = styled.div`
    margin-top: auto;
`;
const Wrapper = styled.div`
    width: 100%;
    background-color: var(--main-teal-color);
`;

const FooterRow = styled.div`
    margin-top:1em;
    padding:1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between
`;

const Header = styled.h5`
    font-size: 1.2em;
    font-family: Lato-Black;
    color: var(--main-orange-color);
    padding-top: 0.5em;
    padding-bottom: 0.2em;
`;

const ListItemBold = styled.li`
    color: #FFF;
    font-size: 0.8em;
    font-family: Lato-Bold;
`;

const ListItem = styled.li`
    color: #FFF;
    font-size: 0.8em;
    font-family: Lato-Bold;
`;

const PartnerLogo = styled.img`
    margin-right: 2em;
    width: 50%;
    margin-bottom: 1.3em;
`;

const CopyrightText = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    padding: 0.5em;
    width: 100%;
    font-family: Lato-Bold;
    color: var(--main-teal-color);
    background-color: var(--main-orange-color);
`;

const LogoContainer = styled.div`
    display: flex;
`;
function Footer() {
    const [footer, setFooter] = useState<FooterType>({} as FooterType);

    useEffect(() => {
        const getFooter = async() => {
            const response = await FooterAPI.get();
            setFooter(response);
        }
        getFooter();
    }, []);

    return (
        <FooterContainer>
            <Wrapper>
                <FooterRow>
                    <ul>
                        <li>
                            <Header>Contact</Header>
                        </li>
                        <ListItemBold>Opening Hours:</ListItemBold>
                        <ListItem>{footer.opening_hours}</ListItem>
                        <ListItemBold>Telephone:</ListItemBold>
                        <ListItem>{footer.tel}</ListItem>
                    </ul>
                    <ul>
                        <li>
                            <Header>Quick Links</Header>
                        </li>
                        <a href="/PrivacyCookieNotice">
                            <ListItem>Privacy & Cookie Notice</ListItem>
                        </a>
                        <a href="/UseOfCookies">
                            <ListItem>Use of Cookies</ListItem>
                        </a>
                        <a href="/Faqs">
                            <ListItem>FAQs</ListItem>
                        </a>
                        <a href="/ContactUs">
                            <ListItem>Contact us</ListItem>
                        </a>
                        <a href={footer.tandc} target="_blank">
                            <ListItem>Terms and Conditions</ListItem>
                        </a>
                    </ul>
                    <ul>
                        <li>
                            <Header>Our Partners</Header>
                        </li>
                        <LogoContainer>
                            <a href={footer.fs_url} target="_blank" style={{width: "30%"}}>
                                <PartnerLogo src="/images/logo-white.svg" alt="fleet-solutions" />
                            </a>
                                
                            <a href={footer.hes_url} target="_blank" style={{ width: "30%" }}>
                                <PartnerLogo src="/images/hes-logo-2019-white.svg" alt="home-electronics" />
                            </a>
                        </LogoContainer>
                    </ul>
                </FooterRow>
            </Wrapper>
            <CopyrightText>@FleetSolutions {new Date().getFullYear()}</CopyrightText>
        </FooterContainer>
    );
}
export default Footer;
